/**
 * Created by Languagenut on 15/04/2019.
 */

import React  from 'react';
import {Alert} from 'react-bootstrap'

export default class MyAlert extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggle:false,
        };
    }

    componentWillUnmount(){

    }

    componentDidMount(){

    }

    getIcon(){
        switch(this.props.variant){
            case "warning" : return "fa-exclamation" ; break;
            case "danger" :  return "fa-skull-crossbones"; break;
            case "success" : return "fa-check-circle"; break;
        }
    }

    onClick(){

    }

    render(){
        return <Alert variant={this.props.variant}>
            <table><tr><td><span style={{paddingLeft:"10px"}}>{this.props.children}</span></td></tr></table>
        </Alert>
    }
}